module.exports = __webpack_public_path__ + "images/Half_1_About_Corp.jpg?8f30274";


//////////////////
// WEBPACK FOOTER
// ./assets/component/about/images/Half_1_About_Corp.jpg
// module id = 330
// module chunks = 0